module.exports = "<template>\n    <div class=\"col-xs-12\" style=\"background-color: #fff; padding: 10px;\">\n        <slot></slot>\n    </div>\n</template>\n";